export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/shop-exclusives.6038505b.svg","height":32,"width":32};